import { Flex, Text, Button } from "@chakra-ui/react";
import { useMobileBreakpoint } from "../../utils/useBreakpoints";

interface ValkyraeSubscribeBannerProps {
  isHidden: boolean;
  onSubscribeClick: () => void;
}

export function ValkyraeSubscribeBanner({
  isHidden,
  onSubscribeClick,
}: ValkyraeSubscribeBannerProps) {
  const isMobileBreakpoint = useMobileBreakpoint();

  return (
    <Flex
      position="fixed"
      transform={isHidden ? "translateY(100%)" : "translateY(0%)"}
      transition="transform 0.3s ease-in-out"
      width="100%"
      maxWidth="1336px"
      bottom={0}
      margin="auto"
      zIndex={2}
      alignItems="center"
      justifyContent="center"
      borderRadius="24px 24px 0px 0px"
      backdropFilter="blur(18px)"
      background="linear-gradient(328deg, rgba(20, 21, 23, 0.90) 64.1%, rgba(255, 90, 44, 0.90) 314.68%)"
      boxSizing="border-box"
      px="24px"
      pt={isMobileBreakpoint ? "16px" : "40px"}
      pb={isMobileBreakpoint ? "32px" : "40px"}
      gap={isMobileBreakpoint ? "16px" : "32px"}
      flexDirection={isMobileBreakpoint ? "column" : "row"}
      filter={
        isHidden ? "none" : "drop-shadow(0px -4px 52px rgba(0, 0, 0, 0.40))"
      }
      sx={{
        isolation: "isolate",
        _before: {
          content: `""`,
          position: "absolute",
          inset: 0,
          padding: "1px",
          borderRadius: "inherit",
          background:
            "linear-gradient(to top, transparent, var(--chakra-colors-transparent-white-20))",
          WebkitMask:
            "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
          WebkitMaskComposite: "xor",
          maskComposite: "exclude",
          pointerEvents: "none",
          zIndex: -1,
        },
      }}
    >
      <Text
        color="dune.dune"
        fontFamily="Bricolage Grotesque"
        fontSize={isMobileBreakpoint ? "16px" : "24px"}
        fontWeight="600"
        lineHeight="130%"
        textAlign="center"
      >
        Special promo! Unlock{" "}
        <span style={{ transform: "skew(-12deg)", display: "inline-block" }}>
          Apollyon
        </span>{" "}
        + over 100,000 titles for one full year
      </Text>
      <Button
        variant="primary"
        onClick={onSubscribeClick}
        p={isMobileBreakpoint ? "6px 16px" : "8px 24px"}
        borderRadius={isMobileBreakpoint ? "18px" : "12px"}
        width={isMobileBreakpoint ? "124px" : "200px"}
      >
        <Text
          fontSize="12px"
          fontWeight="500"
          letterSpacing=".75px"
          lineHeight="11px"
        >
          Subscribe
        </Text>
      </Button>
    </Flex>
  );
}
